export default __webpack_public_path__ + "static/media/DSCN2323.20e659fc.JPG";